/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoxDto
 */
export interface BoxDto {
    /**
     * 主键ID
     * @type {number}
     * @memberof BoxDto
     */
    id?: number;
    /**
     * 箱子编号
     * @type {string}
     * @memberof BoxDto
     */
    code?: string;
    /**
     * 唛头号
     * @type {string}
     * @memberof BoxDto
     */
    markNo?: string;
    /**
     * 纸箱类型 1库存用纸箱 2运输用纸箱
     * @type {number}
     * @memberof BoxDto
     */
    boxType?: number;
    /**
     * 计费物料 ID：大于 0 表示参与计费的系统物料，0 表示不参与计费的自定义箱
     * @type {number}
     * @memberof BoxDto
     */
    materialId?: number;
    /**
     * 是否单独保管 0不单独保管 1单独保管
     * @type {number}
     * @memberof BoxDto
     */
    separateStore?: number;
    /**
     * 重量(kg)
     * @type {number}
     * @memberof BoxDto
     */
    wtKg?: number;
    /**
     * CBM(立方米)
     * @type {number}
     * @memberof BoxDto
     */
    cbm?: number;
    /**
     * 体积长度(厘米)
     * @type {number}
     * @memberof BoxDto
     */
    length?: number;
    /**
     * 体积宽度(厘米)
     * @type {number}
     * @memberof BoxDto
     */
    width?: number;
    /**
     * 体积高度(厘米)
     * @type {number}
     * @memberof BoxDto
     */
    height?: number;
    /**
     * 是否可用 0不可用 1可用
     * @type {number}
     * @memberof BoxDto
     */
    enable?: number;
    /**
     * 是否删除 0未删除 1已删除
     * @type {number}
     * @memberof BoxDto
     */
    deleteStatus?: number;
    /**
     * 是否使用 0未使用 1已使用
     * @type {number}
     * @memberof BoxDto
     */
    used?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof BoxDto
     */
    userId?: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof BoxDto
     */
    warehouseId?: number;
    /**
     * 订单ID（运输箱包装作业归属）
     * @type {number}
     * @memberof BoxDto
     */
    orderId?: number;
    /**
     * 是否包含入库检查有误商品：0 否，1 是
     * @type {number}
     * @memberof BoxDto
     */
    containsErrorGoods?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof BoxDto
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BoxDto
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the BoxDto interface.
 */
export function instanceOfBoxDto(value: object): value is BoxDto {
    return true;
}

export function BoxDtoFromJSON(json: any): BoxDto {
    return BoxDtoFromJSONTyped(json, false);
}

export function BoxDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoxDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'boxType': json['boxType'] == null ? undefined : json['boxType'],
        'materialId': json['materialId'] == null ? undefined : json['materialId'],
        'separateStore': json['separateStore'] == null ? undefined : json['separateStore'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
        'used': json['used'] == null ? undefined : json['used'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'containsErrorGoods': json['containsErrorGoods'] == null ? undefined : json['containsErrorGoods'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function BoxDtoToJSON(json: any): BoxDto {
    return BoxDtoToJSONTyped(json, false);
}

export function BoxDtoToJSONTyped(value?: BoxDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'markNo': value['markNo'],
        'boxType': value['boxType'],
        'materialId': value['materialId'],
        'separateStore': value['separateStore'],
        'wtKg': value['wtKg'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'enable': value['enable'],
        'deleteStatus': value['deleteStatus'],
        'used': value['used'],
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'orderId': value['orderId'],
        'containsErrorGoods': value['containsErrorGoods'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

